import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ValidateServiceService as AuthGuard } from './shareModule/services/validate-service.service';

import { AdminHomeComponent } from './admin/admin-home/admin-home.component';
import { FeedbacksComponent } from './admin/auth/feedbacks/feedbacks.component';
import { ClientShareReviewLinkComponent } from './admin/client-share-review-link/client-share-review-link.component';
import { DashboardAdminComponent } from './admin/layout/dashboard-admin/dashboard-admin.component';
import { NewErrorPageComponent } from './admin/new-error-page/new-error-page.component';
import { NewHomepageComponent } from './admin/new-homepage/new-homepage.component';
import { NewReviewUploadImageComponent } from './admin/new-review-upload-image/new-review-upload-image.component';
import { NewUseCaseComponent } from './admin/new-use-case/new-use-case.component';
import { SchedulingComponent } from './admin/sub-admin/scheduling/scheduling.component';
import { UserShareReviewLinkComponent } from './admin/user-share-review-link/user-share-review-link.component';

import { CustomerShoppingComponent } from './customers/customer-shopping/customer-shopping.component';
import { VouchersComponent } from './customers/vouchers/vouchers.component';
import { BusinessJoinFormComponent } from './business/bussiness-join-form/business-join-form.component';
import { BusinessModule } from './business/business.module';

const routes: Routes = [
  { path: 'admin/login', component: NewHomepageComponent },
  {
    path: 'admin',
    component: DashboardAdminComponent,
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    data: {
      allowedRoles: ['admin'],
    },
  },
  {
    path: 'biz/join',
    component: BusinessJoinFormComponent
    // loadChildren: () =>
    //   import('./business/business.module').then((m) => m.BusinessModule),
  },
  { path: 'feedbacks/:id', component: FeedbacksComponent },
  { path: 'use-case', component: NewUseCaseComponent },
  { path: 'error/:id', component: NewErrorPageComponent },
  { path: 'mobile/:id', component: CustomerShoppingComponent },
  { path: 'vouchers/:id', component: VouchersComponent },
  {
    path: 'adminTwo',
    component: AdminHomeComponent,
  },
  {
    path: 'scheduling',
    component: SchedulingComponent,
  },
  {
    path: 'review-image-upload',
    component: NewReviewUploadImageComponent,
    // canActivate: [AuthGuard],
    // data: {
    //   allowedRoles: ["admin"]
    // }
  },
  {
    path: 'user-review-share',
    component: UserShareReviewLinkComponent,
    // canActivate: [AuthGuard],
    // data: {
    //   allowedRoles: ["admin"]
    // }
  },
  {
    path: 'client-review-share',
    component: ClientShareReviewLinkComponent,
    // canActivate: [AuthGuard],
    // data: {
    //   allowedRoles: ["admin"]
    // }
  },
  // ***** Write New Routes and import either in Admin/customer module router file *****
  // {
  //   path: '',
  //   loadChildren: () =>
  //     import('./customers/customers.module').then((m) => m.CustomersModule),
  // },
  //Admin
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    useHash: false,
    scrollPositionRestoration: 'enabled',   
    // paramsInheritanceStrategy: 'always',
  }), BusinessModule /** Has only 1 page and that page is lagging */],
  exports: [RouterModule]
})
export class AppRoutingModule { }
